<!-- <template>
  <div class="row">
    <div class="col-lg-3 col-sm-6 col-12" @click="goToLowStock" style="cursor: pointer;" title="View Details">
      <div class="dash-widget">
        <div class="dash-widgetimg">
          <span><img src="../../../assets/img/icons/dash3.svg" alt="img" /></span>
        </div>
        <div class="dash-widgetcontent">
          <h5>
            <vue3-autocounter
              class="counter"
              ref="counter"
              :startAmount="0"
              :delay="3"
              :endAmount="data.lowstock"
              :duration="2"
              :autoinit="true"
            />
          </h5>
          <h6>Low Stock</h6>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-sm-6 col-12" @click="goToNoStock" style="cursor: pointer;" title="View Details">
      <div class="dash-widget dash1">
        <div class="dash-widgetimg">
          <span><img src="../../../assets/img/icons/dash4.svg" alt="img" /></span>
        </div>
        <div class="dash-widgetcontent">
          <h5>
            <vue3-autocounter
              class="counter"
              ref="counter"
              :startAmount="0"
              :delay="3"
              :endAmount="data.nostock"
              :duration="2"
              :autoinit="true"
            />
          </h5>
          <h6>Out of Stock</h6>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-sm-6 col-12" @click="goToAllStock" style="cursor: pointer;" title="View Details">
      <div class="dash-widget dash2">
        <div class="dash-widgetimg">
          <span><img src="../../../assets/img/icons/dash1.svg" alt="img" /></span>
        </div>
        <div class="dash-widgetcontent">
          <h5>
            <vue3-autocounter
              class="counter"
              ref="counter"
              :startAmount="0"
              :delay="3"
              :endAmount="data.totalitems"
              :duration="3"
              :autoinit="true"
            />
          </h5>
          <h6>Total Items</h6>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-sm-6 col-12">
      <div class="dash-widget dash">
        <div class="dash-widgetimg">
          <span><img src="../../../assets/img/icons/dash2.svg" alt="img" /></span>
        </div>
        <div class="dash-widgetcontent">
          <h5>
            ₹<vue3-autocounter
              class="counter"
              ref="counter"
              :startAmount="0"
              :delay="3"
              :endAmount="data.itemsvalue"
              :duration="3"
              :autoinit="true"
            />
          </h5>
          <h6>Stock Value</h6>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <div class="card-title">Consumpion by Department (Current Month)</div>
        </div>
        <div class="card-body">
          <div class="chartjs-wrapper-demo">
            <apexchart
              type="donut"
              height="220"
              :options="donutchart"
              :series="deptseries"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <div class="card-title">Most Purchased (Current Month)</div>
        </div>
        <div class="card-body">
          <div class="chartjs-wrapper-demo">
            <apexchart
              type="donut"
              height="220"
              :options="piechart"
              :series="categoryseries"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-7 col-sm-12 col-12 d-flex">
      <div class="card flex-fill">
        <div class="card-header pb-0 d-flex justify-content-between align-items-center">
          <h5 class="card-title mb-0">Purchase & Issued</h5>
          <div class="graph-sets">
            <ul>
              <li class="me-4">
                <span>Purchases</span>
              </li>
              <li class="ms-2">
                <span>Issued</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="card-body">
          <apexchart
            type="bar"
            ref="chart"
            height="300"
            :options="basicAreaChart"
            :series="barchartseries"
          ></apexchart>
        </div>
      </div>
    </div>
    <div class="col-lg-5 col-sm-12 col-12 d-flex">
      <div class="card flex-fill">
        <div class="card-header pb-0 d-flex justify-content-between align-items-center">
          <h4 class="card-title mb-0">Most Consumed</h4>
          <div class="dropdown">
            <a
              href="javascript:void(0);"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              class="dropset"
            >
              <i class="fa fa-ellipsis-v"></i>
            </a>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <li>
                <router-link to="saleslist" class="dropdown-item"
                  >Issue List</router-link
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive dataview datatableIndex">
            <a-table :columns="mostcomcolumns" :data-source="data.mostconsumed" @change="onChange">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'itemid'">
                  <div class="productimgname">
                    <router-link to="productlist">{{ record.itemname }}</router-link>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6 col-sm-12 col-12 d-flex">
      <div class="card mb-0">
        <div class="card-body justify-content-between">
          <h4 class="card-title">Low on stock</h4>
          <div class="table-responsive dataview datatableIndex">
            <a-table :columns="columns" :data-source="data.lowstocklist" @change="onChange">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'itemid'">
                  <div class="productimgname">
                    
                    <router-link to="productlist">{{ record.itemname }}</router-link>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-sm-12 col-12 d-flex">
      <div class="card mb-0">
        <div class="card-body justify-content-between">
          <h4 class="card-title">Out of stock</h4>
          <div class="table-responsive dataview datatableIndex">
            <a-table :columns="columns" :data-source="data.nostocklist" @change="onChange">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'itemid'">
                  <div class="productimgname">
                    
                    <router-link to="productlist">{{ record.itemname }}</router-link>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { ref } from "vue";
import { mapGetters } from 'vuex';
const currentDate = ref(new Date());
const columns = [
  {
    title: "Item Name",
    dataIndex: "itemname",
    key: "itemid",
    sorter: {
      compare: (a, b) => {
        a = a.itemname.toLowerCase();
        b = b.itemname.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Category",
    dataIndex: "category",
    sorter: {
      compare: (a, b) => {
        a = a.category.toLowerCase();
        b = b.category.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Available",
    dataIndex: "available",
    key: "available",
    sorter: {
      compare: (a, b) => {
        a = a.available;
        b = b.available;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
];
const mostcomcolumns = [
  {
    title: "Item Name",
    dataIndex: "itemname",
    key: "itemid",
    sorter: {
      compare: (a, b) => {
        a = a.itemname.toLowerCase();
        b = b.itemname.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Category",
    dataIndex: "category",
    sorter: {
      compare: (a, b) => {
        a = a.category.toLowerCase();
        b = b.category.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Count",
    dataIndex: "total",
    sorter: {
      compare: (a, b) => {
        a = a.total;
        b = b.total;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
];
const deptChart = {
  chart: {
    height: 220,
    stacked: true,
    toolbar: {
      show: false,
    },
    type: 'donut',
  },
  dataLabels: {
    enabled: false
  },
  responsive: [{
    breakpoint: 480,
    options: {
      chart: {
        width: 200
      },
      legend: {
        show: false
      }
    }
  }],
  legend: {
    position: 'right',
  },
};

const catChart = {
  chart: {
    height: 220,
    stacked: true,
    toolbar: {
      show: false,
    },
    type: 'donut',
  },
  dataLabels: {
    enabled: false
  },
  responsive: [{
    breakpoint: 480,
    options: {
      chart: {
        width: 200
      },
      legend: {
        show: false
      }
    }
  }],
  legend: {
    position: 'right',
  },
};

const basicAreaChart = {
    chart: {
      id: "vuechart-puchase-issued",
      type: 'bar',
      height: 300,
      stacked: true,
        toolbar: {
          show: false,
        },
        zoom: {
                enabled: true
        }
    },
    colors: ['#28C76F', '#EA5455'],
    dataLabels: {
        enabled: false
    },
    responsive: [{
      breakpoint: 280,
      options: {
          legend: {
          position: '',
          offsetY: 40,
          }
      }
    }],
    plotOptions: {
      bar: {
          horizontal: false,
          columnWidth: '20%',
          endingShape: 'rounded'
      },
    },
    xaxis: {
      categories: [],
    },
    fill: {
      opacity: 1
    },
  
};
const data = {
    "lowstock": 0,
    "nostock": 0,
    "nostocklist": [],
    "lowstocklist": [],
    "deptconsumption": [],
    "mostconsumed": [],
    "mostpurchased": [],
    "purchase_issued": {}
};


export default {
  data() {
    return {
      basicAreaChart: basicAreaChart,
      donutchart: deptChart,
      piechart: catChart,
      deptseries: [],
      categoryseries: [],
      barchartseries: [], 
      data,
      columns,
      mostcomcolumns,
      startdate: currentDate,
    };
  },
  computed: {
    ...mapGetters(['getCurrentLocation']),

    currentLocation() { return this.getCurrentLocation; },
    
    locationName() {
      const loc = this.currentLocation;
      return loc ? Object.keys(loc) : null;
    },
    locationId() {
      const loc = this.currentLocation;
      return loc ? loc.id: null;
    },
  },
  methods: {
    goToLowStock() {
      this.$router.push({ path: '/productlist', query: { category: 'low_stock' } });
    },
    goToNoStock() {
      this.$router.push({ path: '/productlist', query: { category: 'out_of_stock' } });
    },
    goToAllStock() {
      this.$router.push({ path: '/productlist', query: { category: 'all' } });
    },
    async getDashboard() {
      axios
      .get(`/v1/items/dashboard?locationid=${this.locationId}`)
      .then(response => {
        this.data = response.data
        var labels = [];
        var chartdata = [];
        this.data.deptconsumption.forEach(row => {
          labels.push(row.department);
          chartdata.push(row.total);
        });
        this.deptseries = chartdata;
        this.donutchart = {
          ...this.donutchart,
          labels: labels
        }
        var catlabels = [];
        var catchartdata = [];
        this.data.mostpurchased.forEach(row => {
          catlabels.push(row.itemname);
          catchartdata.push(row.count);
        });
        this.categoryseries = catchartdata; 
        this.piechart = {
          ...this.piechart,
          labels: catlabels
        }

        const purchase_issue = this.data.purchase_issued
        this.barchartseries = [{name: 'Purchases', data: purchase_issue.purchases},
                {name: 'Issued', data: purchase_issue.dispatches}]
        this.basicAreaChart = {
          ...this.basicAreaChart,
          xaxis: {
            categories: purchase_issue.month
          }
        };
        
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      });
    },
  },
  beforeMount() {
    this.getDashboard();
  },
};
</script>
<style scoped>
.dash-widget.dash2:hover {
  background-color: rgba(245, 245, 245, 0.916); 
}
.dash-widget.dash1:hover {
  background-color: rgba(245, 245, 245, 0.916); 
}
.dash-widget:hover {
  background-color: rgba(245, 245, 245, 0.916); 
}
</style> -->

<template>
  <div>
    <!-- ====================== DASHBOARD CONTENT ====================== -->
    <div v-if="ready">
      <div class="row">
        <!-- Low Stock -->
        <div class="col-lg-3 col-sm-6 col-12" @click="goToLowStock" style="cursor: pointer;" title="View Details">
          <div class="dash-widget">
            <div class="dash-widgetimg"><span><img src="../../../assets/img/icons/dash3.svg" alt="img" /></span></div>
            <div class="dash-widgetcontent">
              <h5><vue3-autocounter class="counter" :startAmount="0" :endAmount="data.lowstock" :duration="2" :autoinit="true" /></h5>
              <h6>Low Stock</h6>
            </div>
          </div>
        </div>

        <!-- Out of Stock -->
        <div class="col-lg-3 col-sm-6 col-12" @click="goToNoStock" style="cursor: pointer;" title="View Details">
          <div class="dash-widget dash1">
            <div class="dash-widgetimg"><span><img src="../../../assets/img/icons/dash4.svg" alt="img" /></span></div>
            <div class="dash-widgetcontent">
              <h5><vue3-autocounter class="counter" :startAmount="0" :endAmount="data.nostock" :duration="2" :autoinit="true" /></h5>
              <h6>Out of Stock</h6>
            </div>
          </div>
        </div>

        <!-- Total Items -->
        <div class="col-lg-3 col-sm-6 col-12" @click="goToAllStock" style="cursor: pointer;" title="View Details">
          <div class="dash-widget dash2">
            <div class="dash-widgetimg"><span><img src="../../../assets/img/icons/dash1.svg" alt="img" /></span></div>
            <div class="dash-widgetcontent">
              <h5><vue3-autocounter class="counter" :startAmount="0" :endAmount="data.totalitems" :duration="3" :autoinit="true" /></h5>
              <h6>Total Items</h6>
            </div>
          </div>
        </div>

        <!-- Stock Value -->
        <div class="col-lg-3 col-sm-6 col-12">
          <div class="dash-widget dash">
            <div class="dash-widgetimg"><span><img src="../../../assets/img/icons/dash2.svg" alt="img" /></span></div>
            <div class="dash-widgetcontent">
              <h5>₹<vue3-autocounter class="counter" :startAmount="0" :endAmount="data.itemsvalue" :duration="3" :autoinit="true" /></h5>
              <h6>Stock Value</h6>
            </div>
          </div>
        </div>
      </div>

      <!-- Charts & Tables (unchanged – just moved inside v-if) -->
      <div class="row">
        <div class="col-md-6">
          <div class="card">
            <div class="card-header"><div class="card-title">Consumption by Department (Current Month)</div></div>
            <div class="card-body">
              <apexchart type="donut" height="220" :options="donutchart" :series="deptseries"></apexchart>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="card">
            <div class="card-header"><div class="card-title">Most Purchased (Current Month)</div></div>
            <div class="card-body">
              <apexchart type="donut" height="220" :options="piechart" :series="categoryseries"></apexchart>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-7 col-sm-12 col-12 d-flex">
          <div class="card flex-fill">
            <div class="card-header pb-0 d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">Purchase & Issued</h5>
              <div class="graph-sets"><ul><li class="me-4"><span>Purchases</span></li><li class="ms-2"><span>Issued</span></li></ul></div>
            </div>
            <div class="card-body">
              <apexchart type="bar" height="300" :options="basicAreaChart" :series="barchartseries"></apexchart>
            </div>
          </div>
        </div>

        <div class="col-lg-5 col-sm-12 col-12 d-flex">
          <div class="card flex-fill">
            <div class="card-header pb-0 d-flex justify-content-between align-items-center">
              <h4 class="card-title mb-0">Most Consumed</h4>
              <div class="dropdown">
                <a href="javascript:void(0);" data-bs-toggle="dropdown" class="dropset"><i class="fa fa-ellipsis-v"></i></a>
                <ul class="dropdown-menu"><li><router-link to="/saleslist" class="dropdown-item">Issue List</router-link></li></ul>
              </div>
            </div>
            <div class="card-body">
              <div class="table-responsive dataview datatableIndex">
                <a-table :columns="mostcomcolumns" :data-source="data.mostconsumed" @change="onChange">
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'itemid'">
                      <div class="productimgname"><router-link to="/productlist">{{ record.itemname }}</router-link></div>
                    </template>
                  </template>
                </a-table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-sm-12 col-12 d-flex"><div class="card mb-0"><div class="card-body justify-content-between"><h4 class="card-title">Low on stock</h4>
          <div class="table-responsive dataview datatableIndex">
            <a-table :columns="columns" :data-source="data.lowstocklist" @change="onChange">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'itemid'"><div class="productimgname"><router-link to="/productlist">{{ record.itemname }}</router-link></div></template>
              </template>
            </a-table>
          </div>
        </div></div></div>

        <div class="col-lg-6 col-sm-12 col-12 d-flex"><div class="card mb-0"><div class="card-body justify-content-between"><h4 class="card-title">Out of stock</h4>
          <div class="table-responsive dataview datatableIndex">
            <a-table :columns="columns" :data-source="data.nostocklist" @change="onChange">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'itemid'"><div class="productimgname"><router-link to="/productlist">{{ record.itemname }}</router-link></div></template>
              </template>
            </a-table>
          </div>
        </div></div></div>
      </div>
    </div>

    <!-- ====================== LOCATION MODAL ====================== -->
   <LocationModal
  :value="showLocationModal"
  @input="showLocationModal = $event"
  :locations="locations"
/>

    <!-- ====================== LOADING SPINNER ====================== -->
    <div v-if="!ready" class="text-center py-5">
      <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading…</span></div>
      <p class="mt-2">Loading dashboard…</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { ref } from "vue";
import { mapGetters } from "vuex";
import LocationModal from "@/components/locationModal.vue";

const currentDate = ref(new Date());
const columns = [
  {
    title: "Item Name",
    dataIndex: "itemname",
    key: "itemid",
    sorter: {
      compare: (a, b) => {
        a = a.itemname.toLowerCase();
        b = b.itemname.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Category",
    dataIndex: "category",
    sorter: {
      compare: (a, b) => {
        a = a.category.toLowerCase();
        b = b.category.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Available",
    dataIndex: "available",
    key: "available",
    sorter: {
      compare: (a, b) => {
        a = a.available;
        b = b.available;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
];
const mostcomcolumns = [
  {
    title: "Item Name",
    dataIndex: "itemname",
    key: "itemid",
    sorter: {
      compare: (a, b) => {
        a = a.itemname.toLowerCase();
        b = b.itemname.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Category",
    dataIndex: "category",
    sorter: {
      compare: (a, b) => {
        a = a.category.toLowerCase();
        b = b.category.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Count",
    dataIndex: "total",
    sorter: {
      compare: (a, b) => {
        a = a.total;
        b = b.total;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
];
const deptChart = {
  chart: {
    height: 220,
    stacked: true,
    toolbar: {
      show: false,
    },
    type: 'donut',
  },
  dataLabels: {
    enabled: false
  },
  responsive: [{
    breakpoint: 480,
    options: {
      chart: {
        width: 200
      },
      legend: {
        show: false
      }
    }
  }],
  legend: {
    position: 'right',
  },
};

const catChart = {
  chart: {
    height: 220,
    stacked: true,
    toolbar: {
      show: false,
    },
    type: 'donut',
  },
  dataLabels: {
    enabled: false
  },
  responsive: [{
    breakpoint: 480,
    options: {
      chart: {
        width: 200
      },
      legend: {
        show: false
      }
    }
  }],
  legend: {
    position: 'right',
  },
};

const basicAreaChart = {
    chart: {
      id: "vuechart-puchase-issued",
      type: 'bar',
      height: 300,
      stacked: true,
        toolbar: {
          show: false,
        },
        zoom: {
                enabled: true
        }
    },
    colors: ['#28C76F', '#EA5455'],
    dataLabels: {
        enabled: false
    },
    responsive: [{
      breakpoint: 280,
      options: {
          legend: {
          position: '',
          offsetY: 40,
          }
      }
    }],
    plotOptions: {
      bar: {
          horizontal: false,
          columnWidth: '20%',
          endingShape: 'rounded'
      },
    },
    xaxis: {
      categories: [],
    },
    fill: {
      opacity: 1
    },
  
};

export default {
  components: { LocationModal },

  data() {
    return {
      showLocationModal: false,
      ready: false, // true when dashboard data is loaded
      data: {
        lowstock: 0,
        nostock: 0,
        totalitems: 0,
        itemsvalue: 0,
        nostocklist: [],
        lowstocklist: [],
        deptconsumption: [],
        mostconsumed: [],
        mostpurchased: [],
        purchase_issued: {}
      },
      donutchart: { ...deptChart },
      piechart: { ...catChart },
      basicAreaChart: { ...basicAreaChart },
      deptseries: [],
      categoryseries: [],
      barchartseries: [],
      columns,
      mostcomcolumns,
    };
  },

  computed: {
    ...mapGetters([
      "getLocations",
      "hasMultipleLocations",
      "getCurrentLocationId",
      "isAuthenticated"
    ]),

    locations() {
      return this.getLocations;
    },

    locationId() {
      return this.getCurrentLocationId;
    }
  },

  watch: {
    // Watch authentication
    isAuthenticated: {
      handler(val) {
        if (val) this.checkLocationAndLoad();
      },
      immediate: true
    },

    // Watch location list or current selection
    locations: {
      handler() {
        this.checkLocationAndLoad();
      },
      deep: true
    },

    getCurrentLocationId: {
      handler(newVal) {
        if (newVal) {
          this.loadDashboard();
        }
      }
    },

    // When modal closes (user selected location)
    showLocationModal: {
      handler(val) {
        if (!val && this.getCurrentLocationId) {
          this.loadDashboard();
        }
      }
    }
  },

  mounted() {
    this.$store.dispatch("initializeAuth");
    this.checkLocationAndLoad();
    
  },

  methods: {
    goToLowStock() {
      this.$router.push({ path: "/productlist", query: { category: "low_stock" } });
    },
    goToNoStock() {
      this.$router.push({ path: "/productlist", query: { category: "out_of_stock" } });
    },
    goToAllStock() {
      this.$router.push({ path: "/productlist", query: { category: "all" } });
    },

    checkLocationAndLoad() {
      if (!this.isAuthenticated) return;

      const multiple = this.hasMultipleLocations;
      const selected = !!this.getCurrentLocationId;

      if (multiple && !selected && this.locations.length > 0) {
        this.showLocationModal = true;
      } else if (selected) {
        this.loadDashboard();
      }
    },

    async loadDashboard() {
      if (!this.locationId || this.ready) return;

      try {
        const response = await axios.get(`/v1/items/dashboard?locationid=${this.locationId}`);
        this.data = response.data;

        // Donut: Department Consumption
        const deptLabels = [];
        const deptData = [];
        this.data.deptconsumption.forEach(row => {
          deptLabels.push(row.department);
          deptData.push(row.total);
        });
        this.deptseries = deptData;
        this.donutchart = { ...this.donutchart, labels: deptLabels };

        // Donut: Most Purchased
        const catLabels = [];
        const catData = [];
        this.data.mostpurchased.forEach(row => {
          catLabels.push(row.itemname);
          catData.push(row.count);
        });
        this.categoryseries = catData;
        this.piechart = { ...this.piechart, labels: catLabels };

        // Bar: Purchase & Issued
        const pi = this.data.purchase_issued;
        this.barchartseries = [
          { name: "Purchases", data: pi.purchases },
          { name: "Issued", data: pi.dispatches }
        ];
        this.basicAreaChart = {
          ...this.basicAreaChart,
          xaxis: { categories: pi.month }
        };

      } catch (error) {
        console.error("Dashboard load error:", error);
      } finally {
        this.ready = true;
      }
    },

    onChange() {
      // placeholder for a-table pagination/sorting
    }
  }
};
</script>

<style scoped>
/* keep your hover styles */
.dash-widget.dash2:hover,
.dash-widget.dash1:hover,
.dash-widget:hover { background-color: rgba(245, 245, 245, 0.916); }
</style>
